import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    _createVNode("path", {
      "stroke-linecap": "round",
      d: "M17.757 7.193a7.5 7.5 0 00-13.108 6.303M19.3 10.274a7.5 7.5 0 01-13.186 6.375"
    }),
    _createVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18.125 5.5v2h-2M7.875 16.5h-2v2"
    }),
    _createVNode("path", {
      "stroke-linecap": "round",
      d: "M12 8v8"
    }),
    _createVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M13.81 10.152c-.12-.53-.803-1.12-1.804-1.12-1 0-1.77.65-1.77 1.47 0 1.864 3.711.906 3.711 3.07 0 .781-.94 1.444-1.94 1.444s-1.694-.615-1.899-1.274"
    })
  ]))
}